import { StyledComponent } from '@emotion/styled';
import LinearProgress, { LinearProgressProps, linearProgressClasses } from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';

import { Theme } from '../../theme/theme';

export const BorderedLinearProgress: StyledComponent<LinearProgressProps> = styled(LinearProgress)(
  ({ theme }: { theme: Theme }) => ({
    borderRadius: 5,
    height: 10,
    [`& .${linearProgressClasses.bar}`]: {
      backgroundColor: theme.palette.success.main,
      borderRadius: 5,
    },
  })
);
